<template>
  <v-main>
    <!--  @load="$event.target.style.opacity = '1'" -->
  <div>
                 <iframe
                 v-show="showMeeting"
              :src="resurl100mslive"
              allow="camera *;microphone *;display-capture *"
              scrolling="no"
              style="
                width:100vw;
                height:100vh;
                border:0;
                overflow:hidden;
                display:block;
              "
            ></iframe>
    <!-- <div id='previewContainer' height="1080" width="1920"></div> -->
    <!-- <div v-if="checksessionmeeting && !showmobilelink"> -->
      <!-- <v-container> -->
        <!-- <v-row align="center" justify="center"> -->
          <!-- <div id='previewContainer' height="80vh" width="80vw" style="width:60vw;height: 60vh;"></div> -->
          <!-- style="width:80vw;height: 60vh;"  -->
          <!-- style="background-color: #137866;" -->
         <!-- <div id='sessionContainer' >
        </div> -->
        <!-- <dyte-meeting id="my-meeting" ref="dytemeeting" >
        </dyte-meeting> -->
        <!-- <rtk-meeting id="my-meeting" ref="dytemeeting" >
        </rtk-meeting> -->
        <!-- <div id="my-meeting" ref="my-meeting">

        </div> -->
      <!-- </v-row> -->
      
      <!-- </v-container> -->
    <!-- </div> -->
    <!-- <video id="my-screen-share-content-video" height="1080" width="1920"></video>
<canvas id="my-screen-share-content-canvas" height="1080" width="1920"></canvas>
    <canvas id="participant-videos-canvas" width="1920" height="1080"></canvas>
    <video id="my-self-view-video" width="1920" height="1080"></video>
<canvas id="my-self-view-canvas" width="1920" height="1080"></canvas> -->
<div class="set-profile"  v-if="!checksessionmeeting && !showmobilelink && !showMeeting">
  <v-container>
    <!-- <div style="color:green" > Zoom Meeting</div> -->
    
    <v-card
    v-if="checkauthlogin"
        class="mx-auto my-12"
        col="12"
            lg="12"
            md="12"
            sm="12"
        max-width="500"
      >
      
      <v-card-title>{{ lg_meet_page.require_login }}</v-card-title>
      <v-card-subtitle>{{ lg_meet_page.require_sub_login }}</v-card-subtitle>
      <v-card-subtitle class="mt-n6">{{ lg_meet_page.require_sub_login2 }}</v-card-subtitle>
      <v-card-text>
        <v-btn
      color="blue"
      class="white--text" block @click="goToLogin()"
            >{{ lg_meet_page.login }} </v-btn
          >
        </v-card-text>
    </v-card>

    <v-card
    v-if="checksendotp"
        class="mx-auto my-12"
        col="12"
            lg="12"
            md="12"
            sm="12"
        max-width="500"
      >
      <v-card-title>{{ lg_meet_page.enter_email }}</v-card-title>
      <v-card-subtitle>{{ lg_meet_page.enter_sub_email }}</v-card-subtitle>
      <v-card-text>
          <form @submit.prevent="checkAndSendOTP()">
            <v-text-field
              v-model="email"
              :label="lg_meet_page.enter_email"
              outlined
            ></v-text-field>
            <v-btn :disabled="disablebtnsendmail" color="primary" min-height="40" type="submit" block>{{
              lg_meet_page.btn_enter
            }}</v-btn>
          </form>
        </v-card-text>
    </v-card>



    <v-dialog v-model="otp_box" max-width="500px" persistent>
      <v-card class="justify-center align-center">
        <v-card-title class="text-h5 justify-center align-center"
          >{{ lg_meet_page.enter_otp }}</v-card-title
        >
       <v-row class="ma-0 justify-center align-center">
        {{ lg_meet_page.enter_sub_otp }}  ( Ref.{{ verify.ref_otp }} )
      </v-row>  
      <!-- <v-row class="ma-0 justify-center align-center">
       {{ dataotp.email }}
      </v-row>  -->

      <v-row class="ma-0 justify-end align-end mt-2">
      <v-btn
      :disabled="!isCoolingDown"
      color="blue"
      class="ma-2 white--text"
      @click="checkAndSendOTP()"
    >
    <v-icon
        left
        dark
      >
      mdi-reload
      </v-icon>
    {{ lg_meet_page.request_a_new_otp }} {{ timecooldown }}
    </v-btn>
  </v-row>

      <v-row class="ma-0 justify-center align-center mt-2">
        <v-col cols="12" xs="2" sm="2" md="2">
          <v-text-field v-model="sendotpdata.otp1"  ref="otp1" class="justify-center" autofocus @focus='$nextTick(() => {
       $refs.otp1.focus()
      });' 
       @keyup='$nextTick(() => {
        if(sendotpdata.otp1 == ""){
        }else{
          if(Number(sendotpdata.otp1) || sendotpdata.otp1=="0"){
            $refs.otp2.focus()
          }else{
            sendotpdata.otp1="";
          }
        }
      });'
      outlined dense hide-details>
          </v-text-field>
        </v-col>
        <v-col cols="12" xs="2" sm="2" md="2">
          <v-text-field v-model="sendotpdata.otp2" ref="otp2" class="justify-center"  
          @keyup='$nextTick(() => {
        if(sendotpdata.otp2 == ""){
        }else{
          if(Number(sendotpdata.otp2) || sendotpdata.otp2=="0"){
            $refs.otp3.focus()
          }else{
            sendotpdata.otp2="";
          }
        }
      });'
       outlined dense hide-details>
          </v-text-field>
        </v-col> <v-col cols="12" xs="2" sm="2" md="2">
          <v-text-field v-model="sendotpdata.otp3" ref="otp3" class="justify-center "  
          @keyup='$nextTick(() => {
        if(sendotpdata.otp3 == ""){
        }else{
          if(Number(sendotpdata.otp3) || sendotpdata.otp3=="0"){
            $refs.otp4.focus()
          }else{
            sendotpdata.otp3="";
          }
        }
      });'
       outlined dense hide-details>
          </v-text-field>
        </v-col> <v-col cols="12" xs="2" sm="2" md="2">
          <v-text-field v-model="sendotpdata.otp4" ref="otp4" class="justify-center " 
          @keyup='$nextTick(() => {
        if(sendotpdata.otp4 == ""){
        }else{
          if(Number(sendotpdata.otp4) || sendotpdata.otp4=="0"){
            $refs.otp5.focus()
          }else{
            sendotpdata.otp4="";
          }
        }
      });'
       outlined dense hide-details>
          </v-text-field>
        </v-col> <v-col cols="12" xs="2" sm="2" md="2">
          <v-text-field v-model="sendotpdata.otp5" ref="otp5" class="justify-center "
          @keyup='$nextTick(() => {
        if(sendotpdata.otp5 == ""){
        }else{
          if(Number(sendotpdata.otp5) || sendotpdata.otp5=="0"){
            $refs.otp6.focus()
          }else{
            sendotpdata.otp5="";
          }
        }
      });'
       outlined dense hide-details>
          </v-text-field>
        </v-col> <v-col cols="12" xs="2" sm="2" md="2">
          <v-text-field v-model="sendotpdata.otp6" ref="otp6" class="justify-center " @keyup='$nextTick(() => {
       
          if(Number(sendotpdata.otp6) || sendotpdata.otp6=="0"){
          }else{
            sendotpdata.otp6="";
          }
      });'
       outlined dense hide-details>
          </v-text-field>
        </v-col>
        <span v-if="otpstatusisfail"  class="red--text">{{ lg_meet_page.theotpyou_entered }} 
          <v-btn
      color="blue"
      class="ma-2 white--text"
      @click="checkAndSendOTP()"
    >
    <v-icon
        left
        dark
      >
      mdi-reload
      </v-icon>
    {{ lg_meet_page.resubmit }}   
    
    </v-btn>

        </span>
      </v-row> 
   
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="otpstatusisfail" color="blue darken-1" text @click="verifyOTP()"
            >Confirm OTP </v-btn
          >
          <v-btn color="red darken-1" text @click="goToListRoom()"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-card v-if="otp_box"  
    class="mx-auto my-12"
        col="12"
            lg="12"
            md="12"
            sm="12"
        max-width="500" >
      <v-card-title primary-title> {{ lg_meet_page.title2 }} </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="verifyOTP()">
          <v-text-field :label="lg_meet_page.txt_otp" v-model="otp" outlined />
          <v-btn color="primary" min-height="40" type="submit" block>{{
              lg_meet_page.btn_enter
            }}</v-btn>
        </v-form>
      </v-card-text>
    </v-card> -->

    <v-card
    v-if="checkmeetpass"
        class="mx-auto my-12"
        col="12"
            lg="12"
            md="12"
            sm="12"
        max-width="500"
      >
      <v-card-title>{{ lg_meet_page.input_password }}</v-card-title>
      <v-card-text>
          <form @submit.prevent="checkPassword()">
            <v-text-field
              v-model="passWord"
              :label="lg_meet_page.label_password"
              outlined
              type="password"
              autocomplete="new-password"
            ></v-text-field>
            <v-btn color="primary" min-height="40" type="submit" block>{{
              lg_meet_page.btn_enter
            }}</v-btn>
          </form>
        </v-card-text>
    </v-card>

    <v-card
    v-if="checksetname"
        class="mx-auto my-12"
        col="12"
            lg="12"
            md="12"
            sm="12"
        max-width="500"
      >
      <v-card-title>{{ lg_meet_page.input_name }}</v-card-title>
      <v-card-text>
          <form @submit.prevent="checkname()">
            <v-text-field
              v-model="userName"
              :label="lg_meet_page.input_name"
              outlined
              type="text"
            ></v-text-field>
            <v-btn :disabled="checknamebtn" color="primary" min-height="40" type="submit" block>{{
              lg_meet_page.join_meeting
            }}</v-btn>
          </form>
        </v-card-text>
    </v-card>
  
   
          <!-- <video id="my-self-view-video" width="1920" height="1080"></video>
<canvas id="my-self-view-canvas" width="1920" height="1080"></canvas> -->


    <!-- <v-row class="pt-10 ma-1">
      <v-col align="center" justify="center"  cols="12" xl="6" lg="6" md="12" sm="12" xs="12">
      </v-col>
      <v-col align="center" justify="center" cols="12" xl="6" lg="6" md="12" sm="12" xs="12">
       <v-row align="center" justify="center">
          
        
     </v-row>
      </v-col>
    </v-row> -->
    <v-dialog v-model="alertDlg" max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          this.titleMessageAlert
        }}</v-card-title>

        <v-card-text class="body">
          {{ this.messageAlert }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            text
            @click="alertDlg = false"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</div>
<div
v-if="showmobilelink"
      class="containermobileall">
<div
v-if="showmobilelink"
      class="containermobile"
      style=""
    >
    <span v-bind:style="{ color: '#000000',fontWeight:'400 !important',align:'left',textDecoration: 'underline',cursor: 'pointer',fontSize:'12px' }" @click="onClickMenu('/')">www.dmeets.co.th</span>
    </div>
    <div
v-if="showmobilelink"
      class="containermobilebottom"
      style=""
    >
    <v-row align="center" justify="center" class="mb-4">
        <v-btn
        style="border-radius: 100px"
        min-height="40"
         color="white"
            @click="checkuserAgent"
            col="12"
            lg="12"
            md="12"
            sm="12"
            size="large"
            rounded
            >
              <span>Download Now</span>
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
        </v-row>

        <!-- <v-row align="center" justify="center" class="mb-4">
          <span v-bind:style="{ color: '#ffffff',fontWeight:'400 !important',align:'left',textDecoration: 'underline',cursor: 'pointer' }"  @click="showmobilelink = false">Skip for now</span>
        </v-row> -->
        
  </div>
  </div>

</div>

  <v-dialog v-model="dialogmeeting_not_started" max-width="500" persistent>
    <v-card>
      <v-card-title >
        <v-spacer />
        <div class="text-center">
          <div>{{ lg_meet_page.meeting_not_started_yet }}</div>
        </div>
        <v-spacer />
      </v-card-title>

      <v-card-text>
        <v-spacer />
        <div class="text-center">
           <!-- v-html="messagemeeting_not_started" -->

            <div style="white-space: pre-wrap;">
              {{ formatMessage() }}
 
          </div>
        </div>
        <v-spacer />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn width="100" v-bind:style="{ color:'#205295',fontWeight:'700 !important' }" color="#ffffff" text   @click="$router.go()"
          >{{ lg_meet_page.refresh_now }}</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog
  v-model="popupalertrecording"
  max-width="500"
  persistent
>
  <v-card
    class="pa-6 text-center"
    style="border-radius: 24px;"
  >
    <!-- Title -->
    <div class="text-h6 font-weight-bold mb-3">
     {{ lg_meet_page.popup_recording_title }}
    </div>

    <!-- Description -->
    <div class="subtitle-2 grey--text text--darken-1 mb-6">
     {{ lg_meet_page.popup_recording_details }}
    </div>

    <!-- Actions -->
    <v-row justify="center" no-gutters>
      <v-btn
        text
        color="red"
        class="mr-6"
       @click="LeaveMeeting()"
      >
        Leave Meeting
      </v-btn>

      <v-btn
        text
        color="black"
         @click="popupalertrecording=false"
      >
        Continue
      </v-btn>
    </v-row>

  </v-card>
</v-dialog>

  <v-dialog
  v-model="popupalertrecordingforstop"
  max-width="500"
>
  <v-card
    class="pa-6 text-center"
    style="border-radius: 24px;"
  >
    <!-- Title -->
    <div class="text-h6 font-weight-bold mb-3">
     {{ lg_meet_page.popup_recording_title_stop }}
    </div>

    <!-- Description -->
    <div class="subtitle-2 grey--text text--darken-1 mb-6">
     {{ lg_meet_page.popup_recording_details_stop_1 }}
    </div>
    <div class="subtitle-2 grey--text text--darken-1 mb-6">
     {{ lg_meet_page.popup_recording_details_stop_2 }}
    </div>

    <!-- Actions -->
    <v-row justify="center" no-gutters>
      <v-btn
       color="primary"
         @click="popupalertrecordingforstop=false"
      >
        {{lg_meet_page.popup_recording_ok}}
      </v-btn>
    </v-row>

  </v-card>
</v-dialog>

<SuccessDialog
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
      />
      <SuccessDialogPush
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
        :link="link"
      />
</v-main>
</template>

<script>
import { getByMeetNameOnlyzoom } from "@/services/api_meetroom";
import api from "@/services/api";
import {lg_joinmeetbtid} from './language/lg_header_joinmeetbyid.js'
import { feature,apiUrl,apiBaseUrl } from "../services/constants.js";
// import { ZoomMtg } from '@zoomus/websdk';
import { lg_meet_page } from "./language/lg_meet_page";
import { server } from "../services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import RealtimeKit from "@cloudflare/realtimekit";
import RealtimeKitClient from '@cloudflare/realtimekit';
import { lg_header_feature } from "./language/lg_header_feature.js";
import NoSleep from '@uriopass/nosleep.js';
import jwtDecode from 'jwt-decode';
import io from "socket.io-client";
// import {
//   HMSReactiveStore,
//   EventBus,
//   Diagnostics,
//   HMSRoomState,
//   HMSNotificationSeverity,
//   selectIsLocalAudioEnabled,
//   selectIsLocalVideoEnabled,
//   selectPeers,
//   selectIsConnectedToRoom,
//   selectVideoTrackByID,
//   selectLocalPeer,
//   selectRoomState,
//   HMSLogLevel,
//   HMSNotificationTypes,
//   selectIsTranscriptionEnabled 
// } from "@100mslive/hms-video-store";



export default {
  components: {
    SuccessDialog,
    SuccessDialogPush
  },
  data: () => ({
    socket:null,
    custom_participant_id:"",
    resurl100mslive:null,
    showMeeting:false,
    noSleep: null,
    meeting:null,
    isLeavingIntentionally: false,
    popupalertrecording:false,
    popupalertrecordingforstop:false,
    checknamebtn:false,
    messagemeeting_not_started:"",
    dialogmeeting_not_started:false,
     timeLeftdatecooldown: 0,
    timerdatecooldown: null,
    countdowndatecooldown: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
    timecooldown: 60,
    isCoolingDown:false,
    disablebtnsendmail:false,
    sendotpdata:{
        otp1:"",
        otp2:"",
        otp3:"",
        otp4:"",
        otp5:"",
        otp6:""
      },
    meet_id:"",
    dialogAdd: false,
    text_color: "text-h5 green--text text-center",
    title: "green",
    message: "green",
    link: "",
    typeroom:"",
    durationtimeend:0,
    showmobilelink:false,
    checkentername:false,
    checksetname:false,
    checkmeetpass:false,
    checksendotp:false,
    checkauthlogin:false,
    otp_box:false,
    otp:null,
    checksessionmeeting:false,
    titleMessageAlert:"",
    messageAlert:"",
    alertDlg:false,
    otpstatusisfail:false,
    dataroom:{},
      authEndpoint : '',
sdkKey : '7d46FNyTSWWCBHrmtrkxzw',
sdkSecret : 'VunUMMyEpCbjdMGh8pGNJ7AGKKjbbwPo',
meetingNumber : '',
passWord : 'dcmin',
role : 1,
userName : '',
userEmail : '',
email:"",
verify: {
        meet_id: "",
        ver_email: "",
        ver_otp: "",
        ref_otp: "",
        ver_expire: "",
      },
registrantToken : '',
zakToken : '', 
leaveUrl : `${window.location.origin}/listroom`,
signature:'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOm51bGwsImlzcyI6ImdWRktRRXpZUlVpVGl2bElhTi1teUEiLCJleHAiOjE3MDMwNDEyMjksImlhdCI6MTcwMjk1NDgzMX0.UNv7rWP7PeL_UZ8nEJyrXFSl8TToLA2hrwq0DTdlgr8',

  }),
  methods: {
    async Clearrtk_token(){
       localStorage.removeItem('rtk_token');
        localStorage.removeItem('rtk_meet_id');
        localStorage.removeItem('rtk_username');
        this.isLeavingIntentionally = false;
    },
   async LeaveMeeting(){
    try {
    if (this.meeting) {
      localStorage.removeItem('rtk_token');
      localStorage.removeItem('rtk_meet_id');
      localStorage.removeItem('rtk_username');
      this.isLeavingIntentionally = true;
      this.popupalertrecording = false;
      await this.meeting.leaveRoom();
    }
  } catch (err) {
    console.error("Leave meeting error:", err);
  }

    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    async _initMeeting(dataroom) { 
  console.log("===============_initMeeting============")
  console.log(dataroom)
  // return;
  const roomCode = dataroom.code;
  let userName = this.userName;
  const authToken = dataroom.authToken;
  this.resurl100mslive = `${dataroom.resurl100mslive}/${roomCode}?auth_token=${authToken}&name=${userName}`;
   console.log("this.resurl100mslive")
  console.log(this.resurl100mslive)


  //       setTimeout(() => {
  //   this.showMeeting = true;
  // }, 2000);

         this.socket = io(`${apiBaseUrl}`, {
          //  path: "/socket.io/",
   transports: ["websocket"],
});
console.log("=====socket=====")
console.log(this.socket)
// if(!this.socket.connected){
//         setTimeout(() => {
//     this.showMeeting = true;
//   }, 2000);
// }







    // this.socket.on("dmeets-meeting-event", (event) => {
        console.log("eventsocket")
      // console.log(event)
      if(event.room_id == this.dataroom.meet_appid && event.user_name == this.userName && event.user_id == this.custom_participant_id){
      switch(event.event_type) {
        case "peer.join.success":
            this.showMeeting = true;
        break;

        case "peer.leave.success":
        case "room.end.success":
           if(!localStorage.getItem(server.TOKEN_KEY) || !localStorage.getItem(server.USER_ID)){
            localStorage.clear();
            localStorage.setItem(feature.LANGUAGE,"gb");
            //  this.Clearrtk_token();
            this.$router.push('/joinmeetid').catch((err) => {});
          }else{
           //  this.Clearrtk_token();
            this.$router.push('/listroom').catch((err) => {});
          }
        break;
      }
      }

    // });

  this.socket.on("connect", () => {
  console.log("socketaa connected");
});

this.socket.on("disconnect", (reason) => {
  console.log("socketaa disconnected", reason);
});

this.socket.on("reconnect", () => {
  console.log("socketaa reconnected");
});

this.socket.onAny((eventName, ...args) => {
  console.log("socketaa event:", eventName, args);
});

  return;

    
     },
    async old_initMeeting(token) { 
      // console.log("เข้า _initMeeting")
      this.checksessionmeeting = true;
const meeting = await RealtimeKitClient.init({
        authToken: token,
        // roomName: 'Mary Sue',
        defaults: {
          audio: false,
          video: false,
        },
      });
      this.meeting = meeting;
      // const plugin = DytePlugin.init();
      // await plugin.enableForAll();
      // await plugin.stores.populate('storeName');


// const plugins = meeting.plugins;
// console.log(plugins)
      await meeting.join();
// console.log(meeting.self)
// console.log(meeting.poll.vote(poll, selectedPollOption))
      document.getElementById('my-meeting').showSetupScreen = false;
      document.getElementById('my-meeting').meeting = meeting;

      // var noSleep = new NoSleep();
      this.noSleep.enable();
      // ใน _initMeeting() หลัง noSleep.enable()
document.addEventListener('visibilitychange', async () => {
  if (document.visibilityState === 'visible') {
    this.noSleep.enable(); // เปิด NoSleep อีกครั้งหลังกลับมา

    // Rejoin อัตโนมัติถ้า meeting หลุดตอน lock screen
    const savedToken = localStorage.getItem('rtk_token');
    const savedMeetId = localStorage.getItem('rtk_meet_id');
    if (savedToken && savedMeetId && !this.checksessionmeeting) {
      console.log('Rejoining after screen unlock...');
      try {
        await this._initMeeting(savedToken);
      } catch (err) {
        console.error('Auto-rejoin failed:', err);
        localStorage.removeItem('rtk_token');
        localStorage.removeItem('rtk_meet_id');
        localStorage.removeItem('rtk_username');
      }
    }
  }
});

      // this.$refs.dytemeeting.meeting = meeting;
      // console.log(this.$refs.dytemeeting.config)
      // console.log(meeting.meta.sessionId)
    
      let checkdatetime;
      if(this.dataroom.tbl_account.acc_plan == "FREE"){
          let hour = 7;
      // 40 คือ 40 นาที
      let secondofmeeting = 0;
      if(this.dataroom.tbl_account.acc_plan == "FREE"){
        secondofmeeting = 40*60;
      }
      // else if(this.dataroom.tbl_account.acc_plan == "PRO"){
      //   secondofmeeting = 60*60;
      // }else if(this.dataroom.tbl_account.acc_plan == "BUSINESS"){
      //   secondofmeeting = 120*60;
      // }else{
      // }
    let getnewdate = new Date(document.getElementById('my-meeting').meeting.meta.meetingStartedTimestamp);
    let offsetDate = new Date(getnewdate.getTime() + hour * 3600000);
    let datatime = offsetDate.toISOString().slice(0, 19).replace('T', ' ');
     checkdatetime = setInterval(async() => {
  // console.log(document.getElementById('my-meeting').meeting.meta.meetingStartedTimestamp);
  //   console.log(new Date());
  //    console.log(new Date(getnewdate.getTime() + (secondofmeeting * 1000)))
  if(new Date() > new Date(getnewdate.getTime() + (secondofmeeting * 1000))){
// console.log(`ผ่านไปแล้ว 10 วินาที`);
 clearInterval(checkdatetime);
  // if(!localStorage.getItem(server.TOKEN_KEY) || !localStorage.getItem(server.USER_ID)){
  //   this.$store.state.global_dialog_push = true;
  //   this.setupAlertDialogPush(
  //         true,
  //         `${this.lg_meet_page.free_meeting_ended}`,
  //         `${this.lg_meet_page.free_meeting_ended_details1} \n ${this.lg_meet_page.free_meeting_ended_details2}`,
  //         "text-h5 red--text text-center",
  //         "/joinmeetid"
  //       );
  //       // return;
  //   }else{
  //     this.$store.state.global_dialog_push = true;
  //       this.setupAlertDialogPush(
  //         true,
  //         `${this.lg_meet_page.free_meeting_ended}`,
  //         `${this.lg_meet_page.free_meeting_ended_details1} \n ${this.lg_meet_page.free_meeting_ended_details2}`,
  //         "text-h5 red--text text-center",
  //         "/listroom"
  //       );
  //         // return;
  //   }
        this.$swal.fire({
  title:`<span style="color:red;">${this.lg_meet_page.free_meeting_ended}</span>`,
  html:`${this.lg_meet_page.free_meeting_ended_details1} <br/> ${this.lg_meet_page.free_meeting_ended_details2}`,
  showDenyButton: true, 
  showCancelButton: false, 
  confirmButtonText: `${this.lg_meet_page.btn_upgrade_now}`,
  denyButtonText: `${this.lg_meet_page.btn_back_to_home}`,
  confirmButtonColor: '#205295',
  denyButtonColor: '#000000',
  allowOutsideClick: false, 
  allowEscapeKey: false,  
  allowEnterKey: false   
}).then((result) => {
  if (result.isConfirmed) {
      if(!localStorage.getItem(server.TOKEN_KEY) || !localStorage.getItem(server.USER_ID)){
    this.$router.push('/pricing').catch((err) => {});
    }else{
    this.$router.push('/billing').catch((err) => {});
    }
  } else if (result.isDenied) {
    if(!localStorage.getItem(server.TOKEN_KEY) || !localStorage.getItem(server.USER_ID)){
    this.$router.push('/pricing').catch((err) => {});
    }else{
    this.$router.push('/billing').catch((err) => {});
    }
  }
});
      localStorage.removeItem('rtk_token');
      localStorage.removeItem('rtk_meet_id');
      localStorage.removeItem('rtk_username');
      this.isLeavingIntentionally = true;
     await meeting.leaveRoom();
     return;
  }
}, 1000);
 }

// document.getElementById('my-meeting').meeting
// console.log(meeting.recording.recordingState);
if(meeting.recording.recordingState === 'RECORDING'){
this.popupalertrecording = true;
}
meeting.recording.on('recordingUpdate', () => {
  const state = meeting.recording.recordingState;

  if (state === 'RECORDING') {
    console.log('🔴 มีคนเริ่ม Record แล้ว!');
    this.popupalertrecording = true;
  } else if (state === 'IDLE') {
    console.log('⏹️ หยุด Record แล้ว');
    this.popupalertrecordingforstop = true;
  } else if (state === 'STARTING') {
    console.log('⏳ กำลังเริ่ม Record...');
  }
});

      meeting.self.on('roomLeft', ({ state }) => {
        // console.log(meeting.meta.sessionId)
        clearInterval(checkdatetime);
          this.Clearrtk_token();



        if(!localStorage.getItem(server.TOKEN_KEY) || !localStorage.getItem(server.USER_ID)){
        }else{
          api.update_recording_used({session_id:meeting.meta.sessionId});
        }

        if (state === 'left') {
          clearInterval(checkdatetime);
          if(!localStorage.getItem(server.TOKEN_KEY) || !localStorage.getItem(server.USER_ID)){
            localStorage.clear();
            localStorage.setItem(feature.LANGUAGE,"gb");
            //  this.Clearrtk_token();
            this.$router.push('/joinmeetid').catch((err) => {});
          }else{
           //  this.Clearrtk_token();
            this.$router.push('/listroom').catch((err) => {});
          }
          
        }else if(state ==='ended'){
          clearInterval(checkdatetime);
          if(!localStorage.getItem(server.TOKEN_KEY) || !localStorage.getItem(server.USER_ID)){
            localStorage.clear();
            localStorage.setItem(feature.LANGUAGE,"gb");
            //  this.Clearrtk_token();
            this.$store.state.global_dialog_push = true;
            this.setupAlertDialogPush(
              true,
              "Meeting Ended",
              "The host has ended the meeting.\n Thank you for joining!",
              "text-h5 red--text text-center",
              "/joinmeetid"
            );
            return;
          }else{
            //  this.Clearrtk_token();
            this.$store.state.global_dialog_push = true;
            this.setupAlertDialogPush(
              true,
              "Meeting Ended",
              "The host has ended the meeting.\n Thank you for joining!",
              "text-h5 red--text text-center",
              "/listroom"
            );
            return;
          }
          
          // this.$router.push("/listroom");
        }else{
          clearInterval(checkdatetime);
          //  this.Clearrtk_token();
          this.$router.push('/listroom').catch((err) => {});
        }

                // ถ้าหน้าจอถูกซ่อน (lock screen / background บน mobile)
        // และ user ไม่ได้ตั้งใจออก → อย่า redirect ให้ rejoin อัตโนมัติเมื่อกลับมา
        if (document.visibilityState === 'hidden' && !this.isLeavingIntentionally) {
          console.warn('roomLeft while hidden — likely lock screen, skipping redirect');
          return;
        }

      });

const participantCount = meeting.participants.count;
// console.log(`Participants joined: ${participantCount}`);
if(this.dataroom.meet_record_on_start_sta == "Y" && participantCount == 0){
  api.startrecordMeetBymeet_appid(this.dataroom.meet_appid);
}

meeting.polls.on('pollsUpdate',async ({ polls, newPoll })  => {
  // console.log(polls[0], newPoll);
  // console.log(meeting.self.userId)
  // console.log(polls[0].createdByUserId)
  polls.forEach(async(x,i)=>{
    if(newPoll && meeting.self.userId == x.createdByUserId){
   await api.addPollVote({
      meet_topic:this.dataroom.meet_topic,
      session_id:meeting.meta.sessionId,
      meet_room_id:this.dataroom.id,
      polls_id:x.id,
      createdby_userid:x.createdByUserId,
      created_by:x.createdBy,
      anonymous:x.anonymous,
      hide_votes:x.hideVotes,
      question:x.question,
      options:JSON.stringify(x.options),
      voted:JSON.stringify(x.voted),
      is_newpoll:newPoll,
      user_create:localStorage.getItem(server.USER_ID)?localStorage.getItem(server.USER_ID):0
    });
  }else{
    await api.updatePollVote(x.id,{polls_id:x.id,
      createdby_userid:x.createdByUserId,
      created_by:x.createdBy,
      anonymous:x.anonymous,
      hide_votes:x.hideVotes,
      question:x.question,
      options:JSON.stringify(x.options),
      voted:JSON.stringify(x.voted),
      user_create:localStorage.getItem(server.USER_ID)?localStorage.getItem(server.USER_ID):0
    });
  }
  })
 
});

// function addMinutes(date, minutes) {
//   date.setMinutes(date.getMinutes() + minutes);
//   return date;
// }
// const startduration = meeting.meta.meetingStartedTimestamp;
// const date = new Date(meeting.meta.meetingStartedTimestamp);
// const newDate = addMinutes(date, 1);
// //this.durationtimeend = newDate;
// console.log(meeting.meta.meetingStartedTimestamp)
// console.log(newDate);



// var h = new Date(meeting.meta.meetingStartedTimestamp).getHours();
// var m = new Date(meeting.meta.meetingStartedTimestamp).getMinutes();
// console.log(h)
// console.log(m)
// console.log(meeting.self);

// this.durationtimeend = setTimeout(()=>{
//   console.log("=====================")
//   console.log(new Date(Date.now()))
//   console.log(newDate)
//   console.log("=====================")
// if(Date.now() >= newDate){
//   console.log("leave room!!!!!");
//   clearTimeout(this.durationtimeend);
//   meeting.leave();
// }   
//     }, 10000);
},
      async JoinMeetingWebSDK(payload){   
        // console.log(payload);    
        // console.log(this.dataroom)
        // await this._initMeeting();
        // return;
        
   this.custom_participant_id = localStorage.getItem(server.USER_ID)?localStorage.getItem(server.USER_ID): "nologin" + Math.floor(Math.random() * 10000);

const resulttoken = await api.generateSignature100msMeet({
    "meet_appid":this.dataroom.meet_appid,
    "name":this.userName,
    "preset_name":localStorage.getItem(server.ROLE) == "Admin" ? "host":"participant-free",
    "custom_participant_id": this.custom_participant_id,
    "meet_name":this.dataroom.meet_name,
    "account_id":localStorage.getItem(server.USER_ID),
    "typeroom":this.typeroom
});
        // return;
// console.log("resulttoken")
// console.log(resulttoken)
if(resulttoken.status == 200 && resulttoken.data){
  // localStorage.setItem('rtk_token', resulttoken.data.token);
  // localStorage.setItem('rtk_meet_id', this.meet_id);
  // localStorage.setItem('rtk_username', this.userName);
  await this._initMeeting(resulttoken.data);
 
}
else if(resulttoken.status == 206){
  if(resulttoken.data.data == "FREE"){
  // this.$swal.fire(this.lg_meet_page.participant_limit_reached, `${this.lg_meet_page.participant_limit_reached_dtails1_free} <br/> ${this.lg_meet_page.participant_limit_reached_dtails2_free}`, "error");
  this.$swal.fire({
  title:`<span style="color:black;">${this.lg_meet_page.participant_limit_reached}</span>`,
  html:`${this.lg_meet_page.participant_limit_reached_dtails1_free} <br/> 
  ${this.lg_meet_page.participant_limit_reached_dtails2_free} `,
  showDenyButton: false, 
  showCancelButton: false, 
  confirmButtonText: `${this.lg_meet_page.btn_back_to_home}`,
  denyButtonText: `${this.lg_meet_page.btn_back_to_home}`,
  confirmButtonColor: '#205295',
  denyButtonColor: '#000000',
  allowOutsideClick: false, 
  allowEscapeKey: false,  
  allowEnterKey: false   
}).then((result) => {
  if (result.isConfirmed) {
    this.$router.push("/").catch((err) => {});
  } else if (result.isDenied) {

  }
});
  }else if(resulttoken.data.data == "PRO"){
    this.$swal.fire({
  title:`<span style="color:black;">${this.lg_meet_page.participant_limit_reached}</span>`,
  html:`${this.lg_meet_page.participant_limit_reached_dtails1_pro} <br/> 
  ${this.lg_meet_page.participant_limit_reached_dtails2_pro} `,
  showDenyButton: false, 
  showCancelButton: false, 
  confirmButtonText: `${this.lg_meet_page.btn_back_to_home}`,
  denyButtonText: `${this.lg_meet_page.btn_back_to_home}`,
  confirmButtonColor: '#205295',
  denyButtonColor: '#000000',
  allowOutsideClick: false, 
  allowEscapeKey: false,  
  allowEnterKey: false   
}).then((result) => {
  if (result.isConfirmed) {
    this.$router.push("/").catch((err) => {});
  } else if (result.isDenied) {

  }
  });

  }else if(resulttoken.data.data == "BUSINESS"){
    this.$swal.fire({
  title:`<span style="color:black;">${this.lg_meet_page.participant_limit_reached}</span>`,
  html:`${this.lg_meet_page.participant_limit_reached_dtails1_business} <br/> 
  ${this.lg_meet_page.participant_limit_reached_dtails2_business} `,
  showDenyButton: false, 
  showCancelButton: false, 
  confirmButtonText: `${this.lg_meet_page.btn_back_to_home}`,
  denyButtonText: `${this.lg_meet_page.btn_back_to_home}`,
  confirmButtonColor: '#205295',
  denyButtonColor: '#000000',
  allowOutsideClick: false, 
  allowEscapeKey: false,  
  allowEnterKey: false   
}).then((result) => {
  if (result.isConfirmed) {
    this.$router.push("/").catch((err) => {});
  } else if (result.isDenied) {

  }
  });
  }else{
    this.$swal.fire({
  title:`<span style="color:black;">${this.lg_meet_page.participant_limit_reached}</span>`,
  html:`${this.lg_meet_page.participant_limit_reached_dtails1_free} <br/> 
  ${this.lg_meet_page.participant_limit_reached_dtails2_free} `,
  showDenyButton: false, 
  showCancelButton: false, 
  confirmButtonText: `${this.lg_meet_page.btn_back_to_home}`,
  denyButtonText: `${this.lg_meet_page.btn_back_to_home}`,
  confirmButtonColor: '#205295',
  denyButtonColor: '#000000',
  allowOutsideClick: false, 
  allowEscapeKey: false,  
  allowEnterKey: false   
}).then((result) => {
  if (result.isConfirmed) {
    this.$router.push("/").catch((err) => {});
  } else if (result.isDenied) {

  }
});
  }
  // this.$swal.fire(this.lg_meet_page.title_error, this.lg_header_feature.titlefreeplanoptions1, "error");
}
return;
},


async checkPassword(){
  if(this.passWord == this.dataroom.meet_pass){
    this.checkmeetpass = false;
    this.checksetname = true;
    // this.JoinMeeting(this);
  }else{
    this.titleMessageAlert = this.lg_meet_page.dialog_check_data;
    this.messageAlert = this.lg_meet_page.invalid_password;
    this.alertDlg = true;
  }
  

},
async checkname(){
  if(this.userName){
      // this.checksessionmeeting = true;
      this.checknamebtn = true;
   await this.JoinMeetingWebSDK(this);
  //  this.checknamebtn = false;
   
  }else{
    this.titleMessageAlert = this.lg_meet_page.dialog_check_data;
    this.messageAlert = this.lg_meet_page.input_name;
    this.alertDlg = true;
  }
  

},
async checkuserAgent(){
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)){
    location.href = "https://apps.apple.com/th/app/dmeets/id6479974253";
      }else{
    location.href = "https://play.google.com/store/apps/details?id=com.dcm.dmeetszoom.dcm_dmeetszoom";
      }
},

async checkAndSendOTP() {
      this.disablebtnsendmail = true;
      this.$store.state.loadMenu = true;
      this.isCoolingDown = false;

      // this.resultJson = await api.getAccountByEmail(this.email);
      // console.log(JSON.stringify(this.resultJson.data));

      // if (this.resultJson.data != null) {
      //   this.$store.state.verify_status = true;
      //   this.$router.push(`/meet/${this.meet_appid}/${this.meet_id}`);
      // } else {
      this.verify.meet_id = this.meet_id;
      this.verify.ver_email = this.email;
      this.verify.ver_otp = Math.floor(
        100000 + Math.random() * 900000
      ).toString();
      this.verify.ref_otp = Math.floor(
        100000000  + Math.random() * 900000
      ).toString();

      var d1 = new Date(),
        d2 = new Date(d1);
      d2.setMinutes(d1.getMinutes() + 5);
      // alert(d2.toString());
      this.verify.ver_expire = d2.toString();

      // console.log(this.verify);
      try {
        await api.deleteVerify(this.verify.meet_id, this.verify.ver_email);
      } catch (error) {
        console.log(error);
      }

      const res = await api.addVerify(this.verify);
      // console.log("res : " + res.status);
      if (res.status == 201) {
        //   this.titleMessageAlert = "Send OTP Success";
        //   this.messageAlert = "กรุณาตรวจ OTP ที่อีเมล์";
        //   this.alertDlg = true;
        const resotp = await api.sendOTP(this.verify);
        if (resotp.status == 200) {
          this.sendotpdata = {
        otp1:"",
        otp2:"",
        otp3:"",
        otp4:"",
        otp5:"",
        otp6:""
      };
      this.disablebtnsendmail = false;
          // this.titleMessageAlert = "Send OTP Success";
          // this.messageAlert = "กรุณาตรวจ OTP ที่อีเมล์";
          this.titleMessageAlert = this.lg_meet_page.dialog_popup_success;
          this.messageAlert = this.lg_meet_page.dialog_popup_success_message;
          // this.alertDlg = true;
          this.checksendotp = false,
          this.otpstatusisfail = false;

    let timeLeft = this.timecooldown;
const timer = setInterval(() => {
  timeLeft--;
  this.timecooldown = timeLeft;

  if (timeLeft <= 0) {
    clearInterval(timer);
    this.isCoolingDown = true;
    this.timecooldown = 60;
  }
}, 1000);
          
          this.otp_box = true;
        } else {
          // this.titleMessageAlert = "Send OTP Fail";
          // this.messageAlert = "กรุณาส่ง OTP ใหม่อีกครั้ง";
          this.disablebtnsendmail = false;
          this.titleMessageAlert = this.lg_meet_page.dialog_popup_fail;
          this.messageAlert = this.lg_meet_page.dialog_popup_fail_message;
          this.alertDlg = true;
        }
      } else {
        // this.titleMessageAlert = "Send OTP Fail";
        // this.messageAlert = "กรุณาส่ง OTP ใหม่อีกครั้ง";
        this.disablebtnsendmail = false;
        this.titleMessageAlert = this.lg_meet_page.dialog_popup_fail;
        this.messageAlert = this.lg_meet_page.dialog_popup_fail_message;
        this.alertDlg = true;
      }
      //}

      this.$store.state.loadMenu = false;
    },
    async verifyOTP() {
      let allotpnumber = this.sendotpdata.otp1+this.sendotpdata.otp2+this.sendotpdata.otp3+this.sendotpdata.otp4+this.sendotpdata.otp5+this.sendotpdata.otp6;
      this.otp = allotpnumber;
      const resOtp = await api.checkOTP(this.meet_id, this.email, this.otp);
        console.log(resOtp);
      if (resOtp.data != null) {
        let dn = new Date();
        let dt = new Date(resOtp.data.ver_expire);
        dt.setHours(dt.getHours() + 7);
        dn.setHours(dn.getHours() + 7);
        // console.log(
        //   "dexp str: " + dt.toLocaleString("th-TH", { timeZone: "UTC" })
        // );

        dt = dt.toLocaleString("th-TH", { timeZone: "UTC" });
        dn = dn.toLocaleString("th-TH", { timeZone: "UTC" });

        // console.log("dexp dt: " + dt);
        // console.log("dexp dn: " + dn);

        if (dn < dt) {
          //   alert("Joint Meeting Success");
          this.$store.state.verify_status = true;
          // this.$router.push(`/meet/${this.meet_appid}/${this.meet_id}`);
          this.otp_box = false;
          if(this.dataroom.meet_pass === null || this.dataroom.meet_pass === ''){
            this.userName = localStorage.getItem(server.FULLNAME);
            this.passWord = 'dcmin';
            this.checkmeetpass = false;
            this.checksetname = true;
            // this.JoinMeeting(this);
          }else{
            this.userName = localStorage.getItem(server.FULLNAME);
            this.passWord = '';
            this.checksetname = false;
            this.checkmeetpass = true;
          }
        } else {
          // this.titleMessageAlert = "OTP Expired";
          // this.messageAlert = "OTP หมดอายุ กรุณาส่ง OTP ใหม่อีกครั้ง";
          this.titleMessageAlert = this.lg_meet_page.dialog_popup_expire;
          this.messageAlert = this.lg_meet_page.dialog_popup_expire_message;
          // this.alertDlg = true;
          this.otpstatusisfail = true;
        }
      }else{
        this.titleMessageAlert = this.lg_meet_page.confirmotp_fail_title;
          this.messageAlert = this.lg_meet_page.confirmotp_fail;
          // this.alertDlg = true;
          this.otpstatusisfail = true;
      }
    },
      updateCountdown(ms) {
      const totalSeconds = Math.floor(ms / 1000);
      this.countdowndatecooldown.days = Math.floor(totalSeconds / (3600 * 24));
      this.countdowndatecooldown.hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
      this.countdowndatecooldown.minutes = Math.floor((totalSeconds % 3600) / 60);
      this.countdowndatecooldown.seconds = totalSeconds % 60;
    },

onClickMenu(link) {
      this.$router.push(link).catch((err) => {});
    },

    goToListRoom() {
      this.$router.push('/listroom').catch((err) => {});
    },
    goToLogin(){ 
      this.$router.push('/login-account').catch((err) => {});
    },
    formatMessage() {
      const parts = [
        this.lg_meet_page.meeting_not_started_yet_details1,
        new Date(this.dataroom.meet_start).toLocaleString("en-US", {
          timeZone: "Asia/Bangkok", 
          dateStyle: "medium",
          timeStyle: "short",
        }) + " (GMT+7).",
        "\n" + this.lg_meet_page.meeting_not_started_yet_details2,
        this.countdowndatecooldown.days ? `${this.countdowndatecooldown.days} ${this.lg_meet_page.day}` : null,
        this.countdowndatecooldown.hours ? `${this.countdowndatecooldown.hours} ${this.lg_meet_page.hours}` : null,
        this.countdowndatecooldown.minutes ? `${this.countdowndatecooldown.minutes} ${this.lg_meet_page.minute}` : null,
        this.countdowndatecooldown.seconds ? `${this.countdowndatecooldown.seconds} ${this.lg_meet_page.second}` : null,
        this.lg_meet_page.meeting_not_started_yet_details3
      ]
      .filter(part => part !== null && part !== "")
      .join(" ");
      
      return parts;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
   computed: {},
   async beforeCreate() {
    window.scroll({ top: 0,left: 0})
      this.$store.state.page_reload = false;

      localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_meet_page = lg_meet_page.meet_page_th)
      : (this.lg_meet_page = lg_meet_page.meet_page_en);

      localStorage.getItem(feature.LANGUAGE) === "th"
        ? this.lg_header_feature = lg_header_feature.lg_header_feature_th
        : this.lg_header_feature = lg_header_feature.lg_header_feature_en;

    },
    async mounted() {


      const ua = navigator.userAgent;
  const isLine = /Line\//i.test(ua);
  const isFacebook = /FBAN|FBAV/i.test(ua);
  const isMessenger = /Messenger|FB_IAB|FB4A|FBIOS/i.test(ua);
  const isInstagram = /Instagram/i.test(ua);
  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isInAppBrowser = isLine || isFacebook || isMessenger || isInstagram;
  // && isAndroid
if (isInAppBrowser) {
  const currentUrl = window.location.href;
  // ✅ Android → ใช้ intent เปิด Chrome
  if (isAndroid) {
    const intentUrl = currentUrl.replace(/^https?:\/\//, 'intent://') 
      // + '#Intent;scheme=https;package=com.android.chrome;end';
      + '#Intent;scheme=https;end';
    window.location.href = intentUrl;
    return;
  }
  // ✅ iOS → ไม่มี intent → เปิด tab ใหม่ (Safari)
 if (isIOS) {
  // const chromeUrl = currentUrl.replace(/^https?:\/\//, 'googlechromes://');
  const chromeUrl = currentUrl.replace(/^https?:\/\//, 'x-safari-https://');
  window.location.href = chromeUrl;

  // Fallback → Safari
  // setTimeout(() => {
  //   window.location.href = currentUrl.replace(/^https?:\/\//, 'x-safari-https://');
  // }, 1500);
  return;
}
}

  // const ua = navigator.userAgent;
  // const isLine = /Line\//i.test(ua);
  // const isFacebook = /FBAN|FBAV/i.test(ua);
  // const isMessenger = /Messenger|FB_IAB|FB4A|FBIOS/i.test(ua);
  // const isInstagram = /Instagram/i.test(ua);
  // const isAndroid = /Android/i.test(ua);
  // const isInAppBrowser = isLine || isFacebook || isMessenger || isInstagram;

  // if (isInAppBrowser && isAndroid) {
  //   // เพิ่ม intent:// สำหรับ Android เพื่อเปิดใน Chrome
  //   const currentUrl = window.location.href;
  //   const intentUrl = currentUrl.replace(/^https?:\/\//, 'intent://') 
  //     // + '#Intent;scheme=https;package=com.android.chrome;end';
  //     + '#Intent;scheme=https;end';
  //   window.location.href = intentUrl;
  //   return;
  // }
  

  let url = window.location.href
      // let result = url.includes("vpaas-magic-cookie-e205800afeca4002aad705d1994953cb");
       let host = (url.split('/')[0] +"//" +url.split('/')[2]);
      let meetId = this.$route.params.appId;
      this.meet_id = this.$route.params.appId;
      // this.typeroom = this.$route.params.typeroom;
      this.typeroom = "meeting";
     try{
      if(meetId){
        this.noSleep = new NoSleep();
        if(localStorage.getItem(server.TOKEN_KEY) && localStorage.getItem(server.TOKEN_KEY) != ""){
          const decodetoken = jwtDecode(localStorage.getItem(server.TOKEN_KEY));
          if(decodetoken.exp < Math.floor(Date.now() / 1000)){
              localStorage.clear();
              localStorage.setItem(feature.LANGUAGE,"gb");
            // this.$store.dispatch("doLogout");
            // return;
          }
        }
       
          const res = await api.getByMeetNameOnly100ms(meetId);
          // console.log(res);
          
          this.dataroom = res.data;
      // const savedToken = localStorage.getItem('rtk_token');
      // const savedMeetId = localStorage.getItem('rtk_meet_id');
      // const savedUsername = localStorage.getItem('rtk_username');

      // if (savedToken && savedMeetId === meetId) {
      //   // Rejoin อัตโนมัติด้วย token เดิม
      //   this.userName = savedUsername || '';
      //   try {
      //     await this._initMeeting(savedToken);
      //     return; // ✅ ข้ามขั้นตอน login/otp/password ทั้งหมด
      //   } catch (err) {
      //     // Token หมดอายุหรือใช้ไม่ได้แล้ว → ล้างแล้ว flow ปกติ
      //     console.warn('Rejoin failed, restarting flow:', err);
      //     localStorage.removeItem('rtk_token');
      //     localStorage.removeItem('rtk_meet_id');
      //     localStorage.removeItem('rtk_username');
      //   }
      // }

          if((Number(localStorage.getItem(server.USER_ID)) !== this.dataroom.account_id) && (new Date() < new Date(this.dataroom.meet_start))){
            // console.log("ไม่ผ่าน");

//                     this.$swal.fire({
//   title:`<span style="color:black;">${this.lg_meet_page.meeting_not_started_yet}</span>`,
//   html:`${this.lg_meet_page.meeting_not_started_yet_details1} ${
//                 new Date(this.dataroom.meet_start).toLocaleString("en-US", {
//                   timeZone: "Asia/Bangkok",
//                   dateStyle: "medium",
//                   timeStyle: "short",
//                 }) + " (GMT+7)"
//               } <br/> 
//   ${this.lg_meet_page.meeting_not_started_yet_details2} ${this.countdowndatecooldown.seconds}<br/> 
//   ${this.lg_meet_page.meeting_not_started_yet_details3}`,
//   showDenyButton: false, 
//   showCancelButton: false, 
//   confirmButtonText: `${this.lg_meet_page.refresh_now}`,
//   denyButtonText: `${this.lg_meet_page.btn_back_to_home}`,
//   confirmButtonColor: '#205295',
//   denyButtonColor: '#000000',
//   allowOutsideClick: false, 
//   allowEscapeKey: false,  
//   allowEnterKey: false   
// }).then((result) => {
//   if (result.isConfirmed) {
//     this.$router.go().catch((err) => {});
//   } else if (result.isDenied) {

//   }
// });
// this.messagemeeting_not_started = `${this.lg_meet_page.meeting_not_started_yet_details1} ${
//                  new Date(this.dataroom.meet_start).toLocaleString("en-US", {
//                    timeZone: "Asia/Bangkok",
//                    dateStyle: "medium",
//                   timeStyle: "short",
//                  }) + " (GMT+7)."
//                } <br/>
//           ${this.lg_meet_page.meeting_not_started_yet_details2} ${this.countdowndatecooldown.seconds}
//           ${this.lg_meet_page.meeting_not_started_yet_details3}`;

  this.dialogmeeting_not_started = true;

 const targetTime = new Date(this.dataroom.meet_start).getTime();
    //  console.log(targetTime)

      this.timerdatecooldown = setInterval(() => {
        const now = new Date().getTime();
          // console.log(now)
        this.timeLeftdatecooldown = targetTime - now;

        if (this.timeLeftdatecooldown <= 0) {
          clearInterval(this.timerdatecooldown);
          this.timeLeftdatecooldown = 0;
           this.$router.go().catch((err) => {});
        } else {
          this.updateCountdown(this.timeLeftdatecooldown);
        }
      }, 1000);
          }

          if(this.dataroom.meet_verify_login === 'Y' && !localStorage.getItem(server.USER_ID)){
            this.checkauthlogin = true;
          }else if(this.dataroom.meet_verify_sta === 'Y'){
            this.checksendotp = true;

          }else if(this.dataroom.meet_pass === null || this.dataroom.meet_pass === ''){
            this.userName = localStorage.getItem(server.FULLNAME);
            this.passWord = 'dcmin';
            this.checkmeetpass = false;
            this.checksetname = true;
            // this.JoinMeeting(this);
          }else{
            this.userName = localStorage.getItem(server.FULLNAME);
            this.passWord = '';
            this.checksetname = false;
            this.checkmeetpass = true;
          }
         
        const {
          data: { meet_appid, meet_sta },
        } = res;
        if (meet_sta !== "Y") {
           this.$store.state.checklinkmeeting = true;
            
this.$router.push("/");
       
        }
        
      }else{
    this.$router.push("/");
       
      }
     }catch(e){
       this.$store.state.checkidmeeting = true;
       this.$router.push("/");
     }

  this.$store.state.meetSta = true;
  this.$store.state.navMenu = false;
  this.$store.state.loadFooter = false;
  // await this.JoinMeetingWebSDK(this);
},
async created() {
  // let url = window.location.href
      // let result = url.includes("vpaas-magic-cookie-e205800afeca4002aad705d1994953cb");
      //  let host = (url.split('/')[0] +"//" +url.split('/')[2]);
      // let meetId = url.split('/')[4].trim();
      // this.meet_id = url.split('/')[4].trim();
      // this.typeroom = url.split('/')[5].trim();
      //   if (this.isMobile() == true) {
      //     this.showmobilelink = true;
      //     // setTimeout(() => {
      //       window.location.replace(
      //     `dmeets://dmeets.dcm.co.th/?meet_appid=${meetId}`
      //   );
      //   //     window.location.replace(
      //   //   "https://play.google.com/store/apps/details?id=com.dcm.dmeetszoom.dcm_dmeetszoom"
      //   // );
      //   // window.location.replace(
      //   //   "https://apps.apple.com/th/app/dmeets/id6479974253"
      //   // );
      // // }, 1000);
      //   // window.location.href = `http://localhost:9291/weblink/deeplink/${this.$route.params.appId}/${this.$route.params.roomName}`;
      //   return;
      // }
        this.$store.state.meetSta = true;
  this.$store.state.navMenu = false;
  this.$store.state.loadFooter = false;
      this.showmobilelink = false;
  // console.log(this.$route.params.roomName);
  return;
  this.JoinMeeting(this);
},
beforeDestroy() {
    if (this.timerdatecooldown) clearInterval(this.timerdatecooldown);
     if (this.socket) {
    this.socket.disconnect();
  }
  },
  watch: {
    timerdatecooldown(newVal) {
      // console.log(newVal)
      this.updateCountdown(newVal);

    },
  },

};

</script>

<style scoped>
.textinform{
  width:75%;
}

@media (min-width: 1260px) {
  .joinmeeting-container {
    margin-top: 15rem
  }
}
/* #my-self-view-video, #my-self-view-canvas {
   width: 100%;
   height: auto;
} */
html,
body,
#jaas-container {
  height: 100vh;
  background: #000;
}

.set-profile {
  height: 100vh;
  background: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
/* .set-meeting{
  height: 100vh;
  width: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
} */
.app-logo {
  width: 150px;
}
/* #my-self-view-video, #my-self-view-canvas {
   width: 100%;
   height: auto;
} */
/* #sessionContainer {
  margin: 2rem;
} */

#participant-videos-canvas {
   width: 100%;
   height: auto;
}
#my-screen-share-content-video, #my-screen-share-content-canvas {
  width: 100%;
  height: auto;
  display: none;
}

img {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    .button {
      border: none;
      color: white;
      padding: 15px 32px;
      text-align: center;
      text-decoration: none;
      display: inline-block;
      display: block;
      margin-left: auto;
      margin-right: auto;
      cursor: pointer;
      border-radius: 5px;
    }
    .button-blue {
      background-color: #008cba;
    } 
    .h1 {
      display: block;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    }

    .h2 {
      display: block;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    }
    .containermobileall{
      height:100vh;
      width: 100vw;
    }
    .containermobile{
      background-image: url('../assets/meetingmobile.png');
      height: 80vh;
      width: 100vw;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .containermobilebottom{
      height: 20vh;
      width: 100vw;
    }

    .v-main {
      /* background-image: linear-gradient(to right, #222471, #22257b, #212786, #202890, #1f299b); */
      height: 100vh;
      width: 100vw;
}

</style>